import { getCloudBluePlanForPeriod } from "@gatsby-plugin-generic-page/helpers/getCloudBluePlanForPeriod"
import { isPlanInputCounterBox } from "@gatsby-plugin-generic-page/helpers/isPlanInputCounterBox"
import type { ProductBox } from "@gatsby-plugin-generic-page/types/productBoxTypes"
import { ProductBoxButtonType } from "@gatsby-plugin-generic-page/types/productBoxTypes"
import { typeMatches } from "@onestore-graphql"
import isEmpty from "~/lib/isEmpty"
import type { PeriodName } from "../../../../lib/api/types"

/**
 * Mirrors the hide condition in ProductBoxWithSaleConfiguration: a box with
 * an AX Configuration (SaleConfiguration.optionsMapping) hides itself when
 * none of its plans (default + mapped) offer the currently selected period.
 * Used by the section to size ProductBoxesGrid to the boxes that will
 * actually render, instead of the section's full (unfiltered) box count.
 */
export function isProductBoxVisibleForPeriod(
  box: ProductBox,
  period?: PeriodName
): boolean {
  const button = box.flatData.buttons[0]

  if (!button || !typeMatches(button.type, ProductBoxButtonType.PLAN)) {
    return true
  }

  const { saleConfiguration, planInputLabel } = button

  if (
    isEmpty(saleConfiguration) ||
    isEmpty(saleConfiguration[0].flatData.defaultCloudBluePlan)
  ) {
    return true
  }

  if (isPlanInputCounterBox(saleConfiguration, planInputLabel)) {
    return true
  }

  const { defaultCloudBluePlan, optionsMapping } = saleConfiguration[0].flatData

  if (!period || isEmpty(optionsMapping)) {
    return true
  }

  return Boolean(
    getCloudBluePlanForPeriod(defaultCloudBluePlan, optionsMapping, period)
  )
}
